<template>

  <div>

    <data-table :title="'Request to ' + this.heading"
        :id="this.type.toLowerCase() + '-action-table'"
        :table-ref="this.type.toLowerCase() + '-action-table'"

        :url="'/view/actions/' + (this.telcoId ? this.type + '/' + this.telcoId : this.type + '/null') + '/' + reqStatus"

        :fields="fields"

        detail-component="request-details"

        :sort-field="sortFields"
        sort-direction="DESC"

        search-placeholder="Site Names, Site IDs, Status, Timeline..."
        :show-refresh="true"
        :showSearch="true"

        :bottom-comp="bComp"
        :bottom-comp-props="bCompProps"

        :hide-org-badge="isTowerCo()"

        :add-action="(isBackhaulCo() || isTelco() || isManager('management|project|admin')) ? addAction : null"
        :add-props="addProps">


        <template slot="request-details" slot-scope="props">

          <el-row :gutter="8.52" :class="formatBG(props.rowData.actionType)" style="padding: 0.852em">

            <el-col :xs="24" :sm="24" :md="24" :lg="12">

            <el-col :span="24">

              <h3 :class="formatRequest(props.rowData.actionType)">
                <org-badge v-if="!isTelco()" :short-name="props.rowData.shortName" :color="props.rowData.colourCode" />
                <div class="pull-right" v-if="props.rowData.actionType === 'RTB' && props.rowData.provider_id">
                  <h5>Provider: <org-badge :short-name="props.rowData.providerShortName" :color="props.rowData.providerColourCode"  />&nbsp;<b class="text-black">{{props.rowData.backhaulType}}</b></h5>
                </div>
              </h3>


              <h4 :class="formatRequest(props.rowData.actionType)">
                <span v-if="(props.rowData.status === 'Rejected' || props.rowData.status === 'Closed')">
                  <b :class="(props.rowData.status === 'Rejected' ? 'text-warning' : 'text-success')">{{props.rowData.status}}</b>
                  &nbsp;|&nbsp;</span><b>
                    <el-badge v-if="props.rowData.status === 'NEW' || props.rowData.status === 'Pending'"
                      :value="props.rowData.status"
                      :type="props.rowData.status === 'Pending' ? 'warning' : 'danger'">
                      {{props.rowData.siteName}}
                    </el-badge>
                    <span v-else>{{props.rowData.siteName}}</span>
                  </b>
                <span v-if="props.rowData.telcoSiteId">&nbsp;({{props.rowData.telcoSiteId}})</span>
              </h4>


              <el-steps class="hidden-sm-and-down" :active="props.rowData.currentStep - 1" :finish-status="formatStep(props.rowData.actionType)" align-center direction="horizontal">
                <el-step v-for="s in props.rowData.stepWorkflow" :key="s.stepName" :description="s.stepName">
                  <template slot="icon">
                    <i :class="s.stepIcon" style="background: inherit;"></i>
                  </template>
                </el-step>
              </el-steps>

            </el-col>


            <el-col style="padding-top: 7.41px;" :xs="24" :sm="24" :md="24" :lg="24" align="left">

              <el-row :gutter="5.28">
                <el-col :xs="24" :sm="24" :md="24" :lg="14" align="left">
                 <el-progress v-if="props.rowData.currentStep >= 0 && props.rowData.totalSteps"
                    :stroke-width="26"
                    :percentage="(props.rowData.currentStep / props.rowData.totalSteps * 100)"
                    :color="progessBar(props.rowData.actionType)"
                    :text-inside="true" />
               </el-col>

               <el-col :xs="24" :sm="24" :md="24" :lg="10" :align="props.rowData.totalSteps ? 'center' : 'left'">

                <span v-html="formatPeriod(props.rowData.Period)" />&nbsp;|&nbsp;
                {{(props.rowData.Period === 'Finished' ? '' : 'Due:')}}
                {{formatDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))}}
                &nbsp;|&nbsp;
                <b>{{formatFriendlyDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))}}</b>

               </el-col>


               <el-col v-if="isDesktop && isTowerCo()" :span="24">
               <br />
                <h5>Client: <b>{{props.rowData.name}}</b></h5>
               </el-col>

            </el-row>


              <small>Ref: <i>{{props.rowData.siteId}}-{{props.rowData.id}}</i></small>

            </el-col>

          </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <site-card :site-data="props.rowData" use-leaflet hide-site height="230px" />
            </el-col>
          </el-row>


        </template>

    </data-table>
</div>

</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import DateMixins from '@/mixins/DateMixins'
import SiteCard from '@/components/sites/SiteCard'

import RequestAction from '@/components/actions/RequestAction'
import RequestStats from '@/components/requests/RequestStats'

import RtxActionDeleteControl from '@/components/requests/RtxActionDeleteControl'

import RequestDetails from '@/components/requests/RequestDetails'

Vue.component('request-details', RequestDetails)
Vue.component('rts-controls', RtxActionDeleteControl)

export default {
  mixins: [DateMixins],

  components: {
    SiteCard
  },

  props: {
    sharer: {
      type: Number,
      default: null
    },

    heading: {
      type: String,
      default: 'Share'
    },

    type: {
      type: String,
      default: 'RTS'
    },

    status: {
      type: String,
      default: 'active'
    },

    rejected: {
      type: Number,
      default: null
    },

    active: {
      type: Number,
      default: null
    },

    closed: {
      type: Number,
      default: null
    }

  },



  methods: {

    formatStatus (value) {
      var color = ''

      switch (value) {
        case 'Closed':
          color = '#67C23A'
          break

        case 'Rejected':
          color = '#E6A23C'
          break

        default:
          color = '#606266' // '#303133'

      }

      return '<span style="color: ' + color + '">' + value + '</span>'
    },



    formatStep (value) {
      let cls = ''

      switch (value) {
        case 'RTS':
          cls = 'success'
          break

        case 'RTU':
          cls = 'primary'
          break

        case 'RTB':
          cls = 'info'
          break

          case 'RTA':
            cls = 'warning'
            break

         case 'RTD':
           cls = 'danger'
           break

      }

      return cls
    },

    formatRequest (value) {
      let cls = ''

      switch (value) {
        case 'RTS':
          cls += 'text-success'
          break

        case 'RTU':
          cls += 'text-primary'
          break

        case 'RTB':
          cls += 'text-info'
          break

          case 'RTA':
            cls += 'text-warning'
            break

            case 'RTD':
              cls += 'text-danger'
              break


      }

      return cls
    },


    formatBG (value) {
      let cls = ''

      switch (value) {
        case 'RTA':
          cls += 'bg-warning-lighten-2'
          break

        case 'RTS':
          cls += 'bg-success-lighten-2'
          break

        case 'RTU':
          cls += 'bg-primary-lighten-1'
          break

        case 'RTB':
          cls += 'bg-info-lighten-2'
          break

        case 'RTD':
           cls += 'bg-danger-lighten-2'
           break

      }

      return cls
    },


    progessBar (value) {
      let cls = '#C6E2FF'

      switch (value) {
        case 'RTA':
          cls = '#E6A23C'
          break

        case 'RTS':
          cls = '#67C23A'
          break

        case 'RTU':
          cls = '#409EFF'
          break

        case 'RTB':
          cls = '#909399'
          break

      case 'RTD':
         cls = 'indianred'
         break

      }

      return cls
    },


    formatDays (value) {
      var color = '#606266'

      if (value < 0) {
        color = 'indianred'
      }

      return '<span style="color: ' + color + '">' + value + '</span>'
    },


    formatPeriod (value) {
      var color = '#606266'

      if (value === 'Finished') {
        color = '#67C23A'
      }

      if (value === 'Overdue') {
        color = 'indianred'
      }

      if (value === 'Month') {
        color = 'slateblue'
      }

      if (value === 'Week') {
        color = 'goldenrod'
      }

      return '<b style="color: ' + color + '">' + value + '</b>'
    },

    changed (req) {
      this.reqStatus = req
    }

  },



  watch: {

    sharer: function (value) {
      this.telcoId = value

      if (this.$refs.rtsActionTable) {
        this.$refs.rtsActionTable.refresh()
      }

      if (this.$refs.rtuActionTable) {
        this.$refs.rtuActionTable.refresh()
      }

      if (this.$refs.rtbActionTable) {
        this.$refs.rtbActionTable.refresh()
      }

      if (this.$refs.rtdActionTable) {
        this.$refs.rtdActionTable.refresh()
      }


    },

    active: function (a) {
      this.rtxActive = Number(a)
      this.bCompProps.active = this.rtxActive
    },

    rejected: function (r) {
      this.rtxRejected = Number(r)
      this.bCompProps.rejected = this.rtxRejected
    },

    closed: function (c) {
      this.rtxClosed = Number(c)
      this.bCompProps.closed = this.rtxClosed
    }

  },



  data () {
    return {
      reqStatus: this.status,

      rtxActive: this.active,
      rtxRejected: this.rejected,
      rtxClosed: this.closed,

      telcoId: this.sharer,

      addAction: RequestAction,
      addProps: {
          type: this.type,
          rowData: this.getTableStruct('actions')
      },
      bComp: RequestStats,
      bCompProps: {
        status: this.status,
        active: this.active,
        rejected: this.rejected,
        closed: this.closed,
        change: this.changed
      },

      sortFields: ['targetDate', 'Period', 'status', 'siteName', 'currentStep'],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: '__slot:request-details',
          title: 'Details'
        },
        {
          name: '__component:rts-controls',
          title: '',
          visisble: this.isTowerCo()
        }
      ]
    }
  },


  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }

    if (this.telcoId && this.isTelco()) {
//      this.sortFields.push('telcoSiteId')
    } else {
      this.sortFields.push('shortName')
    }
  }
}
</script>



// WEBPACK FOOTER //
// RequestTable.vue?62394f66